class Tab {
  private buttonSelector = '.js-tab-button';

  private activeClass = 'isActive';
  private container: HTMLElement;
  private tabButtons: NodeListOf<HTMLElement>;
  private tabContent: NodeListOf<HTMLElement>;

  constructor(container: string | HTMLElement) {
    if (typeof container === 'string') {
      this.container = document.querySelector(container);
    } else {
      this.container = container;
    }

    if (this.container) {
      this.init();
    }
  }

  private init(): void {
    this.setupButtons();
    this.setupContent();
    this.checkforUrlHash();
  }

  private setupButtons(): void {
    this.tabButtons = this.container.querySelectorAll(this.buttonSelector);

    this.tabButtons.forEach(btn => {
      btn.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  private setupContent(): void {
    const contentSelector: string = Array.prototype.slice
      .call(this.tabButtons)
      .map((btn: HTMLElement) => `[data-tab-id="${btn.dataset.tab}"]`)
      .join(',');

    this.tabContent = document.querySelectorAll(contentSelector);
  }

  private onButtonClick(e: Event): void {
    e.preventDefault();
    const target = e.target as HTMLElement;
    const { tab } = target.dataset;
    this.changeActiveTab(tab);
  }

  changeActiveTab(id: string): void {
    this.tabButtons.forEach(btn => {
      btn.classList.remove(this.activeClass);

      if (id === btn.dataset.tab) {
        btn.classList.add(this.activeClass);
      }
    });

    this.tabContent.forEach(tab => {
      tab.classList.remove(this.activeClass);

      if (id === tab.dataset.tabId) {
        tab.classList.add(this.activeClass);
      }
    });

    this.updateHashLocation(id);
  }

  private updateHashLocation(hash: string): void {
    window.history.pushState(null, null, `#${hash}`);
  }

  private checkforUrlHash(): void {
    const { hash } = window.location;

    if (hash) {
      this.changeActiveTab(hash.substring(1));
    }
  }
}

export default Tab;
